import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import railway from "../../Assets/Projects/railway.jpg";
import testseries from "../../Assets/Projects/testseries.png";
import salon from "../../Assets/Projects/salon.jpg";

function Projects() {
  const featureList_Project_1 = [
    "Developed a comprehensive test series management system for students and educators.",
    "Implemented user authentication and authorization features for secure access.",
    "Designed intuitive user interfaces using HTML, CSS, and JavaScript.",
    "Utilized Django (Python) for backend development to manage test creation, distribution, and evaluation."]
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={testseries}
              isBlog={false}
              title="Test-Series Website"
              description="Developed a full-featured Test Series Management System with secure user authentication, real-time scoring, and performance analytics. Built using Django and Razorpay integration, the platform offers intuitive interfaces, a categorized question bank, and responsive design for seamless access across devices."
              features={featureList_Project_1}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={salon}
              isBlog={false}
              title="Hexamart (Salon On-Boarding System)"
              description="Built a full-stack Salon Management System using Django and Next.js, featuring secure user authentication, online appointment booking, real-time notifications, and integrated payment processing. The system includes a salon dashboard for managing bookings, invoices, and reports, with a mobile-responsive design and cloud deployment for scalability."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={railway}
              isBlog={false}
              title="Sarva Suvidhaen (Rail-Madad)"
              description="Developed Railmadad, a data-driven web application using Django, with a responsive frontend built in HTML, CSS, and JavaScript. Integrated real-time CSV data from a government source and visualized it using Chart.js. Implemented secure authentication, dynamic filtering, and deployed the app to the cloud for scalable access."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
